import { Dispatch } from "redux";
import { AppAction } from "../../definitions/Action";
import { CO2Plan } from "./shared/CO2Plan";

export const loadRelatedArticles = async (
  plan: CO2Plan,
  dispatch: Dispatch<AppAction>
): Promise<void> => {};
